<template>
    <div class="bg-white rounded-xl shadow-lg p-6">
        <div class="flex items-center justify-between mb-6">
            <h3 class="text-lg font-semibold text-gray-800">Expected Graduates by Year</h3>
        </div>
        <apexchart type="bar" :options="chartOptions" :series="chartSeries" height="350" />
    </div>
</template>

<script>
export default {
    name: "ExpectedGraduatesByYearChart",
    props: {
        data: {
            type: Array,
            required: true,
            default: () => [
                { student_level: "2025-2026", count: 850 },
                { student_level: "2027-2028", count: 800 },
                { student_level: "2026-2027", count: 593 },
                { student_level: "2024-2025", count: 389 },
                { student_level: "2028-2029", count: 43 }
            ]
        }
    },
    computed: {
        chartSeries() {
            return [{
                name: 'Expected Graduates',
                data: this.data.map(item => item.count)
            }];
        },
        chartOptions() {
            return {
                chart: {
                    type: 'bar',
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                        animateGradually: {
                            enabled: true,
                            delay: 150
                        },
                        dynamicAnimation: {
                            enabled: true,
                            speed: 350
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '70%',
                        dataLabels: {
                            position: 'top'
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val.toLocaleString();
                    },
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        colors: ['#ffffff']
                    },
                    position: 'center',
                    offsetX: 0
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: this.data.map(item => item.student_level),
                    labels: {
                        style: {
                            fontSize: '13px',
                            fontWeight: '600',
                            colors: '#374151'
                        }
                    },
                    title: {
                        text: 'Number of Students',
                        style: {
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#374151'
                        }
                    },
                    max: 900
                },
                yaxis: {
                    labels: {
                        style: {
                            fontSize: '13px',
                            fontWeight: '600',
                            colors: '#374151'
                        }
                    }
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'light',
                        type: 'horizontal',
                        shadeIntensity: 0.25,
                        gradientToColors: undefined,
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 0.85,
                        stops: [0, 50, 100]
                    },
                    colors: ['#0f766e'] // Dark teal color matching the image
                },
                grid: {
                    borderColor: '#e5e7eb',
                    strokeDashArray: 4,
                    xaxis: {
                        lines: {
                            show: true
                        }
                    },
                    yaxis: {
                        lines: {
                            show: false
                        }
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val.toLocaleString() + ' graduates';
                        }
                    },
                    theme: 'light',
                    style: {
                        fontSize: '12px'
                    }
                },
                legend: {
                    show: false
                },
                responsive: [
                    {
                        breakpoint: 768,
                        options: {
                            plotOptions: {
                                bar: {
                                    barHeight: '60%'
                                }
                            },
                            dataLabels: {
                                fontSize: '12px'
                            },
                            xaxis: {
                                labels: {
                                    fontSize: '12px'
                                }
                            }
                        }
                    }
                ]
            };
        }
    }
};
</script>

<style scoped>
/* Component-specific styles can be added here */
</style>